import React, { useRef, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import { sendMessage } from "../../http/patientAPI";

const SendMessage = React.memo(({ patient }) => {
  const messageRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSendMessage = async () => {
    const message = messageRef.current?.value?.trim() || "";

    if (!message) {
      setError("Сообщение не может быть пустым");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setSuccess(false);

      const data = await sendMessage(patient.id, message);

      if (!data) {
        setError("Произошла ошибка при отправке");
        throw new Error("Не получилось отправить сообщение");
      }
      setSuccess(true);
      messageRef.current.value = "";
      setTimeout(() => setSuccess(false), 4500);
    } catch (err) {
      setError(err.message || "Произошла ошибка при отправке");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Отправить сообщение пациенту
      </Typography>

      {!patient?.patientClinicId && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Пациент не сопоставлен с картой клиники
        </Alert>
      )}

      <>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          label="Введите сообщение"
          inputRef={messageRef}
          defaultValue=""
          disabled={loading}
          sx={{ mb: 2 }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            variant="contained"
            onClick={handleSendMessage}
            disabled={loading}
            startIcon={loading && <CircularProgress size={20} />}
          >
            {loading ? "Отправка..." : "Отправить"}
          </Button>

          {success && (
            <Alert severity="success" onClose={() => setSuccess(false)}>
              Сообщение успешно отправлено!
            </Alert>
          )}

          {error && (
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
        </Box>
      </>
    </Box>
  );
});
export default SendMessage;
